import React from "react";
import { withRouter } from "react-router-dom";
import CardLessDataTable from "../../datatables/CardLessDataTableWithSearch";
import { Form, Container, Col } from "react-bootstrap";
import MultiSelect from "react-multi-select-component";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import { withApollo } from "react-apollo";

// ✅ GraphQL Queries & Mutations
const GET_EXAM_ACCESS_STUDENTS = gql`
  query ($exam_paper_id: Int!) {
    getExamAccessUsers(exam_paper_id: $exam_paper_id) {
      mobile
      student_name
      section_id
      section_name
      is_access
    }
  }
`;

const UPDATE_USER_ACCESS = gql`
  mutation UpdateUserExamAccess($exam_paper_id: Int!, $userAccessList: [UserAccessList]!) {
    updateUserExamAccess(exam_paper_id: $exam_paper_id, userAccessList: $userAccessList)
  }
`;

class ExamAccessStudents extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sections: [],
      sectionSelectedvalue: [],
      sectionError: "",
      students: [],
      originalStudents: [], // 🆕 Store initial snapshot
      selectedStudentError: "",
      loadingSpinner: 0,
      submitError: "",
      successMessage: "", // 🆕 For success message
    };
  }

  componentDidMount() {
    this.syncDataWithProps(this.props);
  }

  componentDidUpdate(prevProps) {
    if (this.props.getExamAccessUsers !== prevProps.getExamAccessUsers) {
      this.syncDataWithProps(this.props);
    }
  }

  // ✅ Sync GraphQL data → local state
  syncDataWithProps = (props) => {
    const newData = props.getExamAccessUsers?.getExamAccessUsers;

    if (newData && Array.isArray(newData) && newData.length > 0) {
      const uniqueSections = [
        ...new Map(
          newData.map((item) => [
            item.section_id,
            { value: item.section_id, label: item.section_name },
          ])
        ).values(),
      ];

      this.setState((prevState) => ({
        students: newData,
        originalStudents: JSON.parse(JSON.stringify(newData)), // keep immutable copy
        sections: uniqueSections,
        sectionSelectedvalue:
          prevState.sectionSelectedvalue.length === 0 ? uniqueSections : prevState.sectionSelectedvalue,
      }));
    }
  };

  // ✅ Toggle single checkbox
  handleCheckboxChange = (mobile) => {
    this.setState((prevState) => ({
      students: prevState.students.map((student) =>
        student.mobile === mobile
          ? { ...student, is_access: student.is_access === 1 ? 0 : 1 }
          : student
      ),
      selectedStudentError: "",
      submitError: "",
    }));
  };

  // ✅ Toggle all checkboxes
  handleSelectAll = (e) => {
    const { checked } = e.target;
    this.setState((prevState) => ({
      students: prevState.students.map((student) => ({
        ...student,
        is_access: checked ? 1 : 0,
      })),
      selectedStudentError: "",
    }));
  };

  // ✅ Handle section filter change
  handleMultipleSelectInputChange = (e, name) => {
    if (name === "section") {
      const sectionSelectedvalue = e
        ? e.map((val) => ({ label: val.label, value: val.value }))
        : [];

      this.setState({
        sectionSelectedvalue,
        sectionError: "",
        selectedStudentError: "",
        submitError: "",
      });

      // 🆕 Clear table if all unselected
      if (sectionSelectedvalue.length === 0) {
        this.setState({ filteredStudents: [] });
      }
    }
  };

  // ✅ Submit Form
  handleSubmit = async (e) => {
    e.preventDefault();
    const { sectionSelectedvalue, students, originalStudents } = this.state;

    if (!sectionSelectedvalue.length) {
      this.setState({ sectionError: "Please select Section" });
      return;
    }

    // 🆕 Compare and find changed users only
    const changedUsers = students.filter((student) => {
      const original = originalStudents.find((s) => s.mobile === student.mobile);
      return original && original.is_access !== student.is_access;
    });

    if (changedUsers.length === 0) {
      this.setState({
        successMessage: "No changes to update.",
        submitError: "",
        loadingSpinner: 0,
      });
      return;
    }

    const params = {
      exam_paper_id: parseInt(this.props.location?.state?.exam_id, 10),
      userAccessList: changedUsers.map((item) => ({
        mobile: item.mobile,
        is_access: item.is_access,
      })),
    };

    this.setState({ loadingSpinner: 1, successMessage: "", submitError: "" });

    try {
      await this.updateUserExamAccess(params);

      this.setState({
        loadingSpinner: 0,
        successMessage: "✅ Successfully Updated!",
      });

      // 🆕 Refresh original snapshot for next comparison
      this.setState({
        originalStudents: JSON.parse(JSON.stringify(this.state.students)),
      });

      // 🆕 Redirect after delay
      setTimeout(() => {
        this.props.history.push("/");
      }, 1500);
    } catch (error) {
      console.error("Mutation error:", error);
      this.setState({
        submitError:
          error.graphQLErrors?.map((x) => x.message).join(", ") || "Error occurred",
        loadingSpinner: 0,
      });
    }
  };

  // ✅ GraphQL mutation
  updateUserExamAccess = async (params) => {
    return this.props.updateUserExamAccess({
      variables: {
        exam_paper_id: params.exam_paper_id,
        userAccessList: params.userAccessList,
      },
    });
  };

  render() {
    const {
      sections,
      sectionSelectedvalue,
      sectionError,
      selectedStudentError,
      students,
      loadingSpinner,
      successMessage,
      submitError,
    } = this.state;

    const getStudents = this.props.getExamAccessUsers;
    const loading2 = getStudents.loading;
    const error2 = getStudents.error;

    if (loading2) {
      return (
        <div className="justify-content-center d-flex align-items-center">
          <div className="spinner-border text-primary text-center my-4"></div>
        </div>
      );
    }

    if (error2) {
      alert("Server Error. " + error2.message);
      return null;
    }

    // ✅ Filter students by selected sections
    const filteredStudents =
      sectionSelectedvalue.length > 0
        ? students.filter((item) =>
            sectionSelectedvalue.some((sec) => +sec.value === +item.section_id)
          )
        : [];

    // ✅ Table columns
    const articlecolumns = [
      {
        dataField: "select",
        text: (
          <input
            type="checkbox"
            onChange={this.handleSelectAll}
            checked={
              filteredStudents.length > 0 &&
              filteredStudents.every((s) => s.is_access === 1)
            }
          />
        ),
        formatter: (cell, row) => (
          <input
            type="checkbox"
            checked={row.is_access === 1}
            onChange={() => this.handleCheckboxChange(row.mobile)}
          />
        ),
      },
      { dataField: "student_name", text: "Student Name" },
      { dataField: "mobile", text: "Mobile" },
      { dataField: "section_name", text: "Section Name" },
    ];

    return (
      <Container>
        <Form className="mt-3" onSubmit={this.handleSubmit}>
          <Form.Row>
            {/* ✅ Section Dropdown */}
            <Form.Group as={Col} lg={4} md={12} sm={12} controlId="SelectSection">
              <MultiSelect
                overrideStrings={{
                  allItemsAreSelected: "All Sections are selected.",
                  selectSomeItems: "Select Section",
                }}
                hasSelectAll={true}
                disableSearch={false}
                options={sections}
                value={sectionSelectedvalue}
                onChange={(e) => this.handleMultipleSelectInputChange(e, "section")}
                labelledBy={"section"}
              />
              <Form.Text className="form-text text-danger">{sectionError}</Form.Text>
            </Form.Group>

            {/* ✅ Table */}
            <Form.Group
              as={Col}
              lg={12}
              md={12}
              sm={12}
              style={{
                border: `1px solid ${selectedStudentError ? "red" : "#ccc"}`,
                borderRadius: "5px",
                padding: "10px",
              }}
            >
              <CardLessDataTable
                parentData={filteredStudents || []}
                particlecolumns={articlecolumns}
                name="attendance"
                searchBar={true}
              />
              <Form.Text className="form-text text-danger h6 d-flex justify-content-end">
                {selectedStudentError}
              </Form.Text>
            </Form.Group>

            {/* ✅ Submit Button + Messages */}
            <Form.Group
              as={Col}
              lg={12}
              md={12}
              sm={12}
              className="d-flex justify-content-end ml-5"
            >
              <Col as={Col} lg={3} md={12} sm={12} className="text-center">
                <button
                  type="submit"
                  className="button_style text-uppercase"
                  disabled={loadingSpinner === 1}
                  style={{
                    backgroundColor: "#213046",
                    fontSize: "12px",
                    color: "#ffffff",
                    border: "none",
                    borderRadius: "4px",
                    padding: "9px",
                    width: "100px",
                    cursor: loadingSpinner === 1 ? "not-allowed" : "pointer",
                    opacity: loadingSpinner === 1 ? 0.7 : 1,
                  }}
                >
                  {loadingSpinner === 1 ? (
                    <span className="spinner-border spinner-border-sm"></span>
                  ) : (
                    "Submit"
                  )}
                </button>

                {/* 🆕 Success or Error Message */}
                <div className="d-block mt-3">
                  {successMessage && (
                    <p
                      style={{
                        color: "green",
                        fontWeight: "bold",
                        textAlign: "center",
                        margin: 0,
                      }}
                    >
                      {successMessage}
                    </p>
                  )}
                  {submitError && (
                    <p
                      style={{
                        color: "red",
                        fontWeight: "bold",
                        textAlign: "center",
                        margin: 0,
                      }}
                    >
                      {submitError}
                    </p>
                  )}
                </div>
              </Col>
            </Form.Group>
          </Form.Row>
        </Form>
      </Container>
    );
  }
}

export default withRouter(
  withApollo(
    compose(
      graphql(GET_EXAM_ACCESS_STUDENTS, {
        options: (props) => ({
          variables: {
            exam_paper_id: parseInt(props.location?.state?.exam_id, 10),
          },
          fetchPolicy: "cache-and-network",
        }),
        name: "getExamAccessUsers",
      }),
      graphql(UPDATE_USER_ACCESS, { name: "updateUserExamAccess" })
    )(ExamAccessStudents)
  )
);
